// Fragment "tenants (lot M)" — rempli par son lot de retrofit ; fusionné dans ./index.js.
// Convention : clés plates pointées, valeurs dans les 3 langues, jamais vides.
export default {
  fr: {
    // TenantsList.jsx — purgeTestTenants()
    "tl.purgeBtn": "Purger les cabinets de test",
    "tl.purgeNone": "Aucun cabinet de test détecté.",
    "tl.purgeConfirm": "Supprimer {count} cabinet(s) de test et toutes leurs données ?\nPréservés : {preserved}.\nEx : {sample}…\n\nLeurs abonnements Solunary seront résiliés immédiatement chez Stripe.\nLeurs adresses ne pourront plus jamais être utilisées.\nIrréversible.",
    "tl.purgeBlocked": "{n} cabinet(s) de test non supprimé(s) : Stripe n'a pas confirmé la résiliation de leurs abonnements. Réessayez.",
    "tl.deleteStripeFailed": "Le cabinet n'a pas été supprimé : Stripe n'a pas confirmé la fin de {n} élément(s) (abonnements, paiements ouverts ou paiements de client non réglés). Ce qui a déjà pris fin le reste. Réessayez.",
    "tl.deleteInProgress": "Une suppression de ce cabinet est déjà en cours. Réessayez dans quelques minutes.",
    "tl.deletionUnfinished": "Suppression inachevée",
    "tl.deletionUnfinishedHint": "Stripe n'a pas confirmé la résiliation de tous les abonnements. Supprimez à nouveau pour réessayer, ou abandonnez la suppression pour conserver le cabinet.",
    "tl.retryDelete": "Réessayer la suppression",
    "tl.deleteOwed": "Le cabinet n'a pas été supprimé : Solunary lui doit encore {amounts}. Versez-lui d'abord son solde, puis supprimez-le à nouveau.",
    "tl.deleteOwedPayouts": "{n} versement(s) vers lui sont encore en cours.",
    "tl.deletePayoutsInFlight": "Le cabinet n'a pas été supprimé : {n} versement(s) vers lui sont encore en cours. Attendez qu'ils soient payés, puis supprimez-le à nouveau.",
    "tl.deleteClientPayments": "{n} paiement(s) de client vers lui ne sont pas encore réglés.",
    "tl.deleteClientPaymentsInFlight": "Le cabinet n'a pas été supprimé : {n} paiement(s) de client vers lui ne sont pas encore réglés (le paiement d'un rendez-vous, ou un paiement en cours d'enregistrement). Attendez qu'ils soient encaissés et enregistrés, ou annulés, puis supprimez-le à nouveau.",
    "tl.purgeBlockedOwed": "{n} cabinet(s) de test non supprimé(s) : Solunary leur doit encore de l'argent, ou des paiements de clients vers eux ne sont pas encore réglés. Versez-le d'abord, puis purgez à nouveau.",
    "tl.deletionOwedHint": "La suppression attend : Solunary doit encore de l'argent à ce cabinet, ou des paiements de clients vers lui ne sont pas encore réglés. Le cabinet n'accepte plus de nouveau paiement. Versez-lui son solde, puis supprimez à nouveau pour terminer, ou abandonnez la suppression pour conserver le cabinet.",
    "tl.deletionCommittedOwedHint": "La suppression s'est arrêtée après avoir commencé à retirer les données du cabinet, et Solunary lui doit encore de l'argent (ou des paiements de clients vers lui ne sont pas encore réglés). Le cabinet n'accepte plus de nouveau paiement. Versez-lui son solde, puis supprimez à nouveau pour terminer ; elle ne peut plus être abandonnée.",
    "tl.abandonDeletion": "Abandonner la suppression",
    "tl.abandonConfirm": "Abandonner la suppression du cabinet {tid} ? Le cabinet est conservé. Les abonnements déjà résiliés chez Stripe le restent : le cabinet est servi jusqu'à la fin de la période payée de son forfait, puis coupé, et ses options résiliées sont désactivées.",
    "tl.abandonSuccess": "Suppression abandonnée : le cabinet est conservé.",
    "tl.abandonStripeFailed": "La suppression n'a pas été abandonnée : Stripe n'a pas confirmé la résiliation de {n} abonnement(s) issu(s) d'achats refusés. Réessayez.",
    "tl.abandonNotPending": "Ce cabinet n'a plus de suppression inachevée.",
    "tl.deletionCommittedHint": "La suppression s'est arrêtée après avoir commencé à retirer les données du cabinet. Supprimez à nouveau pour la terminer ; elle ne peut plus être abandonnée.",
    "tl.abandonCommitted": "Cette suppression a déjà commencé à retirer les données du cabinet : elle ne peut plus être abandonnée. Supprimez à nouveau pour la terminer.",
    "tl.purgeSuccess": "{n} cabinets de test supprimés.",
    "tl.purgeError": "Purge échouée",

    // Tenant360.jsx — TrialTile
    "t360.trial.title": "Essai",
    "t360.trial.state.none": "Aucun essai",
    "t360.trial.state.trialing": "En essai",
    "t360.trial.state.ended": "Essai terminé",
    "t360.trial.state.converted": "Converti",
    "t360.trial.daysLeft": "{days} jour(s) restant(s)",
    "t360.trial.endsOn": "Se termine le {date}",
    "t360.trial.endedEarly": "Terminé avant la date prévue ({date})",
    "t360.trial.convertedOn": "Converti le {date}",
    "t360.trial.extend": "Prolonger",
    "t360.trial.extendDays": "Jours",
    "t360.trial.end": "Terminer maintenant",
    "t360.trial.endConfirm": "Terminer l'essai de {name} maintenant ? Stripe facturera immédiatement.",
    "t360.trial.extended": "Essai prolongé de {days} jour(s).",
    "t360.trial.ended": "Essai terminé.",
    "t360.trial.error.TRIAL_NOT_ACTIVE": "L'essai de ce cabinet n'est pas actif.",
    "t360.trial.error.STRIPE_NOT_CONFIGURED": "Stripe n'est pas configuré pour ce cabinet.",
    "t360.trial.error.STRIPE_ERROR": "Stripe a refusé la demande.",
    "t360.trial.error.UNKNOWN": "Une erreur est survenue.",
    // TenantsList.jsx / TenantTableRow.jsx — Trial column
    "tl.colTrial": "Essai",
    "tl.trialDays": "{days} jour(s) restant(s)",
    // Super-admin lists (S4): TenantPicker, pagers, tenants/transactions/customers/leads filters
    "tp.label": "Cabinet",
    "tp.all": "Tous les cabinets",
    "tp.placeholder": "Choisir un cabinet",
    "tp.searchPh": "Rechercher un cabinet…",
    "tp.searching": "Recherche…",
    "tp.empty": "Aucun cabinet ne correspond.",
    "tp.error": "Impossible de charger les cabinets.",
    "tp.retry": "Réessayer",
    "tp.more": "{shown} sur {total} affichés. Précisez la recherche.",
    "tp.current": "Actuel",
    "sal.pagerInfo": "{from}–{to} sur {total}",
    "sal.pagerPrev": "Précédent",
    "sal.pagerNext": "Suivant",
    "sal.retry": "Réessayer",
    "sal.scrollStart": "Afficher les colonnes précédentes",
    "sal.scrollEnd": "Afficher d'autres colonnes",
    "sal.dateFrom": "Du",
    "sal.dateTo": "Au",
    "sal.rangeInvalid": "La date de fin précède la date de début.",
    "sal.dateOutOfRange": "Saisissez des dates réelles comprises entre 0001-01-01 et 9999-12-30.",
    "tl.allStatuses": "Tous les statuts",
    "tl.status.active": "Actif",
    "tl.status.pending": "En attente",
    "tl.status.past_due": "Paiement en retard",
    "tl.status.suspended": "Suspendu",
    "tl.status.cancelled": "Résilié",
    "tl.status.churned": "Perdu",
    "tl.price.monthly": "{amount}/mois",
    "tl.price.annual": "{amount}/an",
    "tl.cycle.monthly": "Facturation mensuelle",
    "tl.cycle.annual": "Facturation annuelle",
    "tl.empty": "Aucun cabinet ne correspond.",
    "tl.countLineFiltered": "{n} cabinets correspondent",
    "tl.countLineBare": "Cabinets sur la plateforme",
    "tx.subtitleBare": "Historique des paiements SaaS.",
    "tx.searchPh": "Rechercher id, session, cabinet, plan…",
    "tx.allStatuses": "Tous les statuts",
    "tx.status.initiated": "Initié",
    "tx.status.completed": "Terminé",
    "tx.status.failed": "Échoué",
    "tx.status.expired": "Expiré",
    "tx.status.refunded": "Remboursé",
    "tx.status.refund_unverified": "Remboursement non vérifié",
    "tx.empty": "Aucune transaction ne correspond.",
    "tx.free": "Gratuit",
    "tx.oneTime": "Achat ponctuel",
    "tx.promotion": "Mise en avant marketplace — {name} ({n} jours)",
    "tx.promotionOne": "Mise en avant marketplace — {name} ({n} jour)",
    "tx.promotionUnnamed": "Mise en avant marketplace",
    "tx.booster": "Booster",
    "tx.noCharge": "Aucun débit",
    "tx.noChargeHint": "Rien n'a été débité : page de paiement d'une inscription à l'essai, première facture d'un essai ou remise totale. Ce n'est pas un paiement.",
    "tx.totalLabel": "Total ({cur})",
    "tx.refundHelp": "La référence de remboursement identifie le paiement. Pour rembourser, ouvrez la vue 360° du cabinet et sélectionnez ce paiement dans le formulaire de remboursement.",
    "tx.allTimeTotals": "Totaux sur tout l'historique de la plateforme. Les filtres ci-dessus ne les modifient pas.",
    "hc.total": "{n} client(s)",
    "sl.total": "{n} demande(s)",
    // Activity / audit / customers copy (S4)
    "act.ev.payment": "Paiement : {status}",
    "act.ev.freeItem": "Article gratuit obtenu",
    "act.ev.noCharge": "Terminé sans débit",
    "act.ev.addon.purchased": "Booster acheté : {addon}",
    "act.ev.addon.cancelled": "Booster annulé : {addon}",
    "act.ev.addon.absorbed": "Module inclus dans le forfait : {addon}",
    "act.ev.addon.blocked": "Le booster n'a pas pu être activé : {addon}",
    "act.ev.addon.retired": "Booster retiré par un changement de forfait : {addon}",
    "act.ev.automation.ran": "Automatisation exécutée : {rule}",
    "act.ev.automation.running": "Automatisation en cours : {rule}",
    "act.ev.automation.failed": "Automatisation en échec : {rule}",
    "act.ev.automation.dryRun": "Simulation d'automatisation : {rule}",
    "act.ev.automation.partial": "Automatisation partielle : {rule}",
    "act.ev.automation.skipped": "Automatisation ignorée : {rule}",
    "act.trigger.tenant.signup": "Inscription d'un cabinet",
    "act.trigger.tenant.churn": "Départ d'un cabinet",
    "act.trigger.invoice.overdue": "Facture en retard",
    "act.trigger.lead.created": "Prospect créé",
    "act.trigger.nps.low": "Score NPS bas",
    "act.trigger.schedule.daily": "Passage quotidien",
    "act.trigger.service.interest": "Intérêt pour un service",
    "act.trigger.tenant.trial_ending": "Fin d'essai proche",
    "act.trigger.tenant.trial_converted": "Essai converti",
    "audit.diffBefore": "Avant",
    "audit.diffAfter": "Après",
    "hc.channel.email": "Courriel",
    "hc.channel.call": "Appel",
    "hc.channel.meeting": "Rencontre",
    "hc.channel.note": "Note",
  },
  en: {
    // TenantsList.jsx — purgeTestTenants()
    "tl.purgeBtn": "Purge test tenants",
    "tl.purgeNone": "No test tenant detected.",
    "tl.purgeConfirm": "Delete {count} test tenant(s) and all their data?\nPreserved: {preserved}.\nE.g.: {sample}…\n\nTheir Solunary subscriptions will be cancelled at Stripe immediately.\nTheir addresses can never be used again.\nIrreversible.",
    "tl.purgeBlocked": "{n} test practice(s) were not deleted: Stripe did not confirm that their subscriptions were cancelled. Try again.",
    "tl.deleteStripeFailed": "The practice was not deleted: Stripe did not confirm the end of {n} item(s) (subscriptions, open checkouts or unpaid client payments). What already ended stays ended. Try again.",
    "tl.deleteInProgress": "A deletion of this practice is already running. Try again in a few minutes.",
    "tl.deletionUnfinished": "Deletion not finished",
    "tl.deletionUnfinishedHint": "Stripe did not confirm the cancellation of every subscription. Delete again to retry, or abandon the deletion to keep the practice.",
    "tl.retryDelete": "Retry deletion",
    "tl.deleteOwed": "The practice was not deleted: Solunary still owes it {amounts}. Pay its balance out first, then delete it again.",
    "tl.deleteOwedPayouts": "{n} payout(s) to it are still in progress.",
    "tl.deletePayoutsInFlight": "The practice was not deleted: {n} payout(s) to it are still in progress. Wait until they are paid, then delete it again.",
    "tl.deleteClientPayments": "{n} client payment(s) to it are not settled yet.",
    "tl.deleteClientPaymentsInFlight": "The practice was not deleted: {n} client payment(s) to it are not settled yet (an appointment's payment, or a payment still being recorded). Wait until they are captured and recorded, or cancelled, then delete it again.",
    "tl.purgeBlockedOwed": "{n} test practice(s) were not deleted: Solunary still owes them money, or client payments to them are not settled yet. Pay it out first, then purge again.",
    "tl.deletionOwedHint": "The deletion is waiting: Solunary still owes this practice money, or client payments to it are not settled yet. The practice takes no new payment. Pay its balance out, then delete again to finish, or abandon the deletion to keep the practice.",
    "tl.deletionCommittedOwedHint": "The deletion stopped after it began removing the practice's records, and Solunary still owes it money (or client payments to it are not settled yet). The practice takes no new payment. Pay its balance out, then delete again to finish; it can no longer be abandoned.",
    "tl.abandonDeletion": "Abandon deletion",
    "tl.abandonConfirm": "Abandon the deletion of practice {tid}? The practice is kept. Subscriptions already cancelled at Stripe stay cancelled: the practice is served until the end of its plan's paid period, then cut off, and its cancelled add-ons are switched off.",
    "tl.abandonSuccess": "Deletion abandoned: the practice is kept.",
    "tl.abandonStripeFailed": "The deletion was not abandoned: Stripe did not confirm the cancellation of {n} subscription(s) from refused purchases. Try again.",
    "tl.abandonNotPending": "This practice no longer has an unfinished deletion.",
    "tl.deletionCommittedHint": "The deletion stopped after it began removing the practice's records. Delete again to finish it; it can no longer be abandoned.",
    "tl.abandonCommitted": "This deletion has already begun removing the practice's records, so it can no longer be abandoned. Delete again to finish it.",
    "tl.purgeSuccess": "{n} test tenants deleted.",
    "tl.purgeError": "Purge failed",

    // Tenant360.jsx — TrialTile
    "t360.trial.title": "Trial",
    "t360.trial.state.none": "No trial",
    "t360.trial.state.trialing": "Trialing",
    "t360.trial.state.ended": "Trial ended",
    "t360.trial.state.converted": "Converted",
    "t360.trial.daysLeft": "{days} day(s) left",
    "t360.trial.endsOn": "Ends on {date}",
    "t360.trial.endedEarly": "Ended before its scheduled end ({date})",
    "t360.trial.convertedOn": "Converted on {date}",
    "t360.trial.extend": "Extend",
    "t360.trial.extendDays": "Days",
    "t360.trial.end": "End now",
    "t360.trial.endConfirm": "End the trial for {name} now? Stripe will invoice immediately.",
    "t360.trial.extended": "Trial extended by {days} day(s).",
    "t360.trial.ended": "Trial ended.",
    "t360.trial.error.TRIAL_NOT_ACTIVE": "This tenant's trial is not active.",
    "t360.trial.error.STRIPE_NOT_CONFIGURED": "Stripe is not configured for this tenant.",
    "t360.trial.error.STRIPE_ERROR": "Stripe refused the request.",
    "t360.trial.error.UNKNOWN": "Something went wrong.",
    // TenantsList.jsx / TenantTableRow.jsx — Trial column
    "tl.colTrial": "Trial",
    "tl.trialDays": "{days} day(s) left",
    // Super-admin lists (S4): TenantPicker, pagers, tenants/transactions/customers/leads filters
    "tp.label": "Practice",
    "tp.all": "All practices",
    "tp.placeholder": "Choose a practice",
    "tp.searchPh": "Search practices…",
    "tp.searching": "Searching…",
    "tp.empty": "No practice matches.",
    "tp.error": "Could not load practices.",
    "tp.retry": "Retry",
    "tp.more": "Showing {shown} of {total}. Refine the search.",
    "tp.current": "Current",
    "sal.pagerInfo": "{from}–{to} of {total}",
    "sal.pagerPrev": "Previous",
    "sal.pagerNext": "Next",
    "sal.retry": "Retry",
    "sal.scrollStart": "Show earlier columns",
    "sal.scrollEnd": "Show more columns",
    "sal.dateFrom": "From",
    "sal.dateTo": "To",
    "sal.rangeInvalid": "The end date is before the start date.",
    "sal.dateOutOfRange": "Enter real dates between 0001-01-01 and 9999-12-30.",
    "tl.allStatuses": "All statuses",
    "tl.status.active": "Active",
    "tl.status.pending": "Pending",
    "tl.status.past_due": "Past due",
    "tl.status.suspended": "Suspended",
    "tl.status.cancelled": "Cancelled",
    "tl.status.churned": "Churned",
    "tl.price.monthly": "{amount}/mo",
    "tl.price.annual": "{amount}/yr",
    "tl.cycle.monthly": "Billed monthly",
    "tl.cycle.annual": "Billed annually",
    "tl.empty": "No practice matches.",
    "tl.countLineFiltered": "{n} practices match",
    "tl.countLineBare": "Practices on the platform",
    "tx.subtitleBare": "SaaS payment history.",
    "tx.searchPh": "Search id, session, practice, plan…",
    "tx.allStatuses": "All statuses",
    "tx.status.initiated": "Initiated",
    "tx.status.completed": "Completed",
    "tx.status.failed": "Failed",
    "tx.status.expired": "Expired",
    "tx.status.refunded": "Refunded",
    "tx.status.refund_unverified": "Refund unverified",
    "tx.empty": "No transaction matches.",
    "tx.free": "Free",
    "tx.oneTime": "One-time purchase",
    "tx.promotion": "Marketplace promotion — {name} ({n} days)",
    "tx.promotionOne": "Marketplace promotion — {name} ({n} day)",
    "tx.promotionUnnamed": "Marketplace promotion",
    "tx.booster": "Booster",
    "tx.noCharge": "No charge",
    "tx.noChargeHint": "Nothing was charged: a trial's signup checkout or first invoice, or a full discount. It is not a payment.",
    "tx.totalLabel": "Total ({cur})",
    "tx.refundHelp": "The refund reference identifies the payment. To refund it, open the practice's 360° view and select the payment in the Refund form.",
    "tx.allTimeTotals": "Totals cover the platform's whole history. The filters above do not change them.",
    "hc.total": "{n} client(s)",
    "sl.total": "{n} request(s)",
    // Activity / audit / customers copy (S4)
    "act.ev.payment": "Payment: {status}",
    "act.ev.freeItem": "Free item acquired",
    "act.ev.noCharge": "Completed with no charge",
    "act.ev.addon.purchased": "Booster purchased: {addon}",
    "act.ev.addon.cancelled": "Booster cancelled: {addon}",
    "act.ev.addon.absorbed": "Add-on included in the plan: {addon}",
    "act.ev.addon.blocked": "Booster could not be activated: {addon}",
    "act.ev.addon.retired": "Booster retired by a plan change: {addon}",
    "act.ev.automation.ran": "Automation ran: {rule}",
    "act.ev.automation.running": "Automation running: {rule}",
    "act.ev.automation.failed": "Automation failed: {rule}",
    "act.ev.automation.dryRun": "Automation dry run: {rule}",
    "act.ev.automation.partial": "Automation partly ran: {rule}",
    "act.ev.automation.skipped": "Automation skipped: {rule}",
    "act.trigger.tenant.signup": "Practice signed up",
    "act.trigger.tenant.churn": "Practice churned",
    "act.trigger.invoice.overdue": "Invoice overdue",
    "act.trigger.lead.created": "Lead created",
    "act.trigger.nps.low": "Low NPS score",
    "act.trigger.schedule.daily": "Daily schedule",
    "act.trigger.service.interest": "Services interest",
    "act.trigger.tenant.trial_ending": "Trial ending",
    "act.trigger.tenant.trial_converted": "Trial converted",
    "audit.diffBefore": "Before",
    "audit.diffAfter": "After",
    "hc.channel.email": "Email",
    "hc.channel.call": "Call",
    "hc.channel.meeting": "Meeting",
    "hc.channel.note": "Note",
  },
  es: {
    // TenantsList.jsx — purgeTestTenants()
    "tl.purgeBtn": "Purgar consultas de prueba",
    "tl.purgeNone": "No se detectó ninguna consulta de prueba.",
    "tl.purgeConfirm": "¿Eliminar {count} consulta(s) de prueba y todos sus datos?\nConservados: {preserved}.\nEj.: {sample}…\n\nSus suscripciones de Solunary se cancelarán de inmediato en Stripe.\nSus direcciones no se podrán volver a usar nunca.\nIrreversible.",
    "tl.purgeBlocked": "{n} consulta(s) de prueba no se eliminaron: Stripe no confirmó la cancelación de sus suscripciones. Inténtelo de nuevo.",
    "tl.deleteStripeFailed": "La consulta no se eliminó: Stripe no confirmó el fin de {n} elemento(s) (suscripciones, pagos abiertos o pagos de clientes sin pagar). Lo que ya terminó sigue terminado. Inténtelo de nuevo.",
    "tl.deleteInProgress": "Ya hay una eliminación de esta consulta en curso. Inténtelo de nuevo en unos minutos.",
    "tl.deletionUnfinished": "Eliminación sin terminar",
    "tl.deletionUnfinishedHint": "Stripe no confirmó la cancelación de todas las suscripciones. Elimine de nuevo para reintentar, o abandone la eliminación para conservar la consulta.",
    "tl.retryDelete": "Reintentar la eliminación",
    "tl.deleteOwed": "La consulta no se eliminó: Solunary todavía le debe {amounts}. Pague primero su saldo y luego elimínela de nuevo.",
    "tl.deleteOwedPayouts": "{n} pago(s) a la consulta siguen en curso.",
    "tl.deletePayoutsInFlight": "La consulta no se eliminó: {n} pago(s) a la consulta siguen en curso. Espere a que se paguen y luego elimínela de nuevo.",
    "tl.deleteClientPayments": "{n} pago(s) de clientes a la consulta aún no están liquidados.",
    "tl.deleteClientPaymentsInFlight": "La consulta no se eliminó: {n} pago(s) de clientes a la consulta aún no están liquidados (el pago de una cita, o un pago que aún se está registrando). Espere a que se cobren y se registren, o se cancelen, y luego elimínela de nuevo.",
    "tl.purgeBlockedOwed": "{n} consulta(s) de prueba no se eliminaron: Solunary todavía les debe dinero, o hay pagos de clientes a ellas aún no liquidados. Páguelo primero y luego vuelva a purgar.",
    "tl.deletionOwedHint": "La eliminación está en espera: Solunary todavía le debe dinero a esta consulta, o hay pagos de clientes a ella aún no liquidados. La consulta ya no acepta pagos nuevos. Pague su saldo y luego elimine de nuevo para terminar, o abandone la eliminación para conservar la consulta.",
    "tl.deletionCommittedOwedHint": "La eliminación se detuvo después de empezar a retirar los datos de la consulta, y Solunary todavía le debe dinero (o hay pagos de clientes a ella aún no liquidados). La consulta ya no acepta pagos nuevos. Pague su saldo y luego elimine de nuevo para terminar; ya no se puede abandonar.",
    "tl.abandonDeletion": "Abandonar la eliminación",
    "tl.abandonConfirm": "¿Abandonar la eliminación de la consulta {tid}? La consulta se conserva. Las suscripciones ya canceladas en Stripe siguen canceladas: la consulta se sirve hasta el final del período pagado de su plan y luego se corta, y sus complementos cancelados se desactivan.",
    "tl.abandonSuccess": "Eliminación abandonada: la consulta se conserva.",
    "tl.abandonStripeFailed": "La eliminación no se abandonó: Stripe no confirmó la cancelación de {n} suscripción(es) de compras rechazadas. Inténtelo de nuevo.",
    "tl.abandonNotPending": "Esta consulta ya no tiene una eliminación sin terminar.",
    "tl.deletionCommittedHint": "La eliminación se detuvo después de empezar a retirar los datos de la consulta. Elimine de nuevo para terminarla; ya no se puede abandonar.",
    "tl.abandonCommitted": "Esta eliminación ya empezó a retirar los datos de la consulta, así que ya no se puede abandonar. Elimine de nuevo para terminarla.",
    "tl.purgeSuccess": "{n} consultas de prueba eliminadas.",
    "tl.purgeError": "Purga fallida",

    // Tenant360.jsx — TrialTile
    "t360.trial.title": "Prueba",
    "t360.trial.state.none": "Sin prueba",
    "t360.trial.state.trialing": "En prueba",
    "t360.trial.state.ended": "Prueba terminada",
    "t360.trial.state.converted": "Convertida",
    "t360.trial.daysLeft": "Quedan {days} día(s)",
    "t360.trial.endsOn": "Termina el {date}",
    "t360.trial.endedEarly": "Terminada antes de la fecha prevista ({date})",
    "t360.trial.convertedOn": "Convertida el {date}",
    "t360.trial.extend": "Prolongar",
    "t360.trial.extendDays": "Días",
    "t360.trial.end": "Terminar ahora",
    "t360.trial.endConfirm": "¿Terminar la prueba de {name} ahora? Stripe facturará de inmediato.",
    "t360.trial.extended": "Prueba prolongada {days} día(s).",
    "t360.trial.ended": "Prueba terminada.",
    "t360.trial.error.TRIAL_NOT_ACTIVE": "La prueba de esta consulta no está activa.",
    "t360.trial.error.STRIPE_NOT_CONFIGURED": "Stripe no está configurado para esta consulta.",
    "t360.trial.error.STRIPE_ERROR": "Stripe rechazó la solicitud.",
    "t360.trial.error.UNKNOWN": "Ocurrió un error.",
    // TenantsList.jsx / TenantTableRow.jsx — Trial column
    "tl.colTrial": "Prueba",
    "tl.trialDays": "Quedan {days} día(s)",
    // Super-admin lists (S4): TenantPicker, pagers, tenants/transactions/customers/leads filters
    "tp.label": "Consulta",
    "tp.all": "Todas las consultas",
    "tp.placeholder": "Elegir una consulta",
    "tp.searchPh": "Buscar una consulta…",
    "tp.searching": "Buscando…",
    "tp.empty": "Ninguna consulta coincide.",
    "tp.error": "No se pudieron cargar las consultas.",
    "tp.retry": "Reintentar",
    "tp.more": "Se muestran {shown} de {total}. Afina la búsqueda.",
    "tp.current": "Actual",
    "sal.pagerInfo": "{from}–{to} de {total}",
    "sal.pagerPrev": "Anterior",
    "sal.pagerNext": "Siguiente",
    "sal.retry": "Reintentar",
    "sal.scrollStart": "Mostrar las columnas anteriores",
    "sal.scrollEnd": "Mostrar más columnas",
    "sal.dateFrom": "Desde",
    "sal.dateTo": "Hasta",
    "sal.rangeInvalid": "La fecha de fin es anterior a la fecha de inicio.",
    "sal.dateOutOfRange": "Introduce fechas reales entre 0001-01-01 y 9999-12-30.",
    "tl.allStatuses": "Todos los estados",
    "tl.status.active": "Activo",
    "tl.status.pending": "Pendiente",
    "tl.status.past_due": "Pago atrasado",
    "tl.status.suspended": "Suspendido",
    "tl.status.cancelled": "Cancelado",
    "tl.status.churned": "Perdido",
    "tl.price.monthly": "{amount}/mes",
    "tl.price.annual": "{amount}/año",
    "tl.cycle.monthly": "Facturación mensual",
    "tl.cycle.annual": "Facturación anual",
    "tl.empty": "Ninguna consulta coincide.",
    "tl.countLineFiltered": "{n} consultas coinciden",
    "tl.countLineBare": "Consultas en la plataforma",
    "tx.subtitleBare": "Historial de pagos SaaS.",
    "tx.searchPh": "Buscar id, sesión, consulta, plan…",
    "tx.allStatuses": "Todos los estados",
    "tx.status.initiated": "Iniciado",
    "tx.status.completed": "Completado",
    "tx.status.failed": "Fallido",
    "tx.status.expired": "Caducado",
    "tx.status.refunded": "Reembolsado",
    "tx.status.refund_unverified": "Reembolso sin verificar",
    "tx.empty": "Ninguna transacción coincide.",
    "tx.free": "Gratis",
    "tx.oneTime": "Compra única",
    "tx.promotion": "Promoción en el marketplace — {name} ({n} días)",
    "tx.promotionOne": "Promoción en el marketplace — {name} ({n} día)",
    "tx.promotionUnnamed": "Promoción en el marketplace",
    "tx.booster": "Booster",
    "tx.noCharge": "Sin cargo",
    "tx.noChargeHint": "No se cobró nada: la página de pago de un alta con prueba, la primera factura de una prueba o un descuento total. No es un pago.",
    "tx.totalLabel": "Total ({cur})",
    "tx.refundHelp": "La referencia de reembolso identifica el pago. Para reembolsarlo, abre la vista 360° de la consulta y selecciona el pago en el formulario de reembolso.",
    "tx.allTimeTotals": "Los totales cubren todo el historial de la plataforma. Los filtros de arriba no los modifican.",
    "hc.total": "{n} cliente(s)",
    "sl.total": "{n} solicitud(es)",
    // Activity / audit / customers copy (S4)
    "act.ev.payment": "Pago: {status}",
    "act.ev.freeItem": "Artículo gratuito obtenido",
    "act.ev.noCharge": "Completado sin cargo",
    "act.ev.addon.purchased": "Booster comprado: {addon}",
    "act.ev.addon.cancelled": "Booster cancelado: {addon}",
    "act.ev.addon.absorbed": "Complemento incluido en el plan: {addon}",
    "act.ev.addon.blocked": "No se pudo activar el booster: {addon}",
    "act.ev.addon.retired": "Booster retirado por un cambio de plan: {addon}",
    "act.ev.automation.ran": "Automatización ejecutada: {rule}",
    "act.ev.automation.running": "Automatización en curso: {rule}",
    "act.ev.automation.failed": "Automatización fallida: {rule}",
    "act.ev.automation.dryRun": "Simulación de automatización: {rule}",
    "act.ev.automation.partial": "Automatización parcial: {rule}",
    "act.ev.automation.skipped": "Automatización omitida: {rule}",
    "act.trigger.tenant.signup": "Alta de una consulta",
    "act.trigger.tenant.churn": "Baja de una consulta",
    "act.trigger.invoice.overdue": "Factura vencida",
    "act.trigger.lead.created": "Contacto creado",
    "act.trigger.nps.low": "Puntuación NPS baja",
    "act.trigger.schedule.daily": "Pase diario",
    "act.trigger.service.interest": "Interés en un servicio",
    "act.trigger.tenant.trial_ending": "Prueba por terminar",
    "act.trigger.tenant.trial_converted": "Prueba convertida",
    "audit.diffBefore": "Antes",
    "audit.diffAfter": "Después",
    "hc.channel.email": "Correo",
    "hc.channel.call": "Llamada",
    "hc.channel.meeting": "Reunión",
    "hc.channel.note": "Nota",
  },
};
